import { Component, OnInit } from "@angular/core";
import { WindowRefService } from "./shared/services/window-ref.service";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
declare var gtag: Function;

@Component({
  selector: "app-root",
  template: `<router-outlet></router-outlet>`,
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "fta";

  url: string;
  params: any;

  constructor(public winref: WindowRefService, public router: Router) {
    this.url = winref.nativeWindow.location.href;
    this.params = this.getParameters(this.url);
  }

  ngOnInit() {
    /* this.setUpAnalytics(); */
    if (this.params != null) {
      this.router.navigate([
        "/loading",
        { name: this.params.name, hash: this.params.hash },
      ]);
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (
          event.urlAfterRedirects.indexOf("?afip=") === -1 ||
          event.urlAfterRedirects.indexOf("?cidi=") === -1
        ) {
          gtag("config", "UA-89152607-13", {
            page_path: event.urlAfterRedirects,
          });

          gtag("config", "G-3XR87VQYN1", {
            page_path: event.urlAfterRedirects,
          });
        }
      });
  }

  getParameters = function (strHref) {
    let strQueryString;
    if (strHref.indexOf("cidi") > -1) {
      return {
        name: "cidi",
        hash: strHref.substr(strHref.indexOf("=") + 1),
      };
    } else if (strHref.indexOf("afip") > -1) {
      return {
        name: "afip",
        hash: strHref.substr(strHref.indexOf("=") + 1),
      };
    }
  };

  /* setUpAnalytics() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
            gtag('config', 'UA-89152607-13',
                {
                    page_path: event.urlAfterRedirects
                }
            );
        });
} */
}
